import request from './../utils/request'

export function getCategoryOptions(params) {
  return request({
    url: 'api/category/getOptions',
    method: 'get',
    params
  })
}
